<template>
  <div>
    <classes-block />
    <div class="q-pa-lg">
      <component
        :is="t.type === 'token' ? 'Token' : 'TokenBlock'"
        :id="'t' + t.start"
        v-for="(t, index) in tm.tokens"
        :token="t"
        :key="t.start"
        :backgroundColor="t.backgroundColor"
        @remove-block="onRemoveBlock"
        @click="testClick(t, index)"
      />
    </div>
    <div class="q-pa-md" style="border-top: 1px solid #ccc">
      <q-btn
        color="red"
        outline
        class="q-mx-md"
        @click="resetBlocks"
        label="Reset"
      />
      <!--<q-btn
        class="q-mx-md"
        outline
        @click="skipCurrentSentence"
        label="Skip"
      />-->
      <q-btn
        color="red"
        outline
        class="q-mx-md"
        @click="backCurrentSentence"
        label="Back"
      />
      <q-btn
        class="q-mx-md"
        color="green"
        outline
        @click="saveTags"
        label="Save"
      />
    </div>
    <q-dialog v-model="prompt" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">人物名</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="text-h7">{{ person }}</div>
        </q-card-section>

        <q-card-section>
          <div class="text-h6">役職名</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input
            dense
            v-model="role"
            autofocus
            @keyup.enter="prompt = false"
          />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Cancel" v-close-popup />
          <q-btn flat label="OK" v-close-popup @click="changeRole()" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="new_prompt" persistent>
      <q-card style="min-width: 350px">

        <q-card-section>
          <div class="text-h6">役職名を入力してください</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input
            dense
            v-model="role"
            autofocus
            @keyup.enter="prompt = false"
          />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Cancel" v-close-popup />
          <q-btn flat label="OK" v-close-popup @click="newRole()" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Token from "./Token";
import TokenBlock from "./TokenBlock";
import ClassesBlock from "./ClassesBlock.vue";
import TokenManager from "./token-manager";
import TreebankTokenizer from "treebank-tokenizer";
import { API } from "aws-amplify";
import { ref } from "vue";

export default {
  name: "AnnotationPage",
  setup() {
    return {
      alert: ref(false),
      confirm: ref(false),
      prompt: ref(false),
      new_prompt: ref(false),
      address: ref(""),
    };
  },
  data: function() {
    return {
      tm: new TokenManager([]),
      tm_index: 0,
      currentSentence: {},
      redone: "",
      tokenizer: new TreebankTokenizer(),
      role: "",
      person: "",
      // お試し
      extract_token: [
        [
          [8, 10, "人物", "藤原経光", "作者"],
          [179, 181, "人物", "広橋貞光", "大夫"],
          [14, 16, "語句"],
          [47, 49, "語句"],
          [66, 68, "語句"],
          [148, 150, "語句"],
          [21, 23, "語句"],
          [27, 29, "語句"],
          [32, 34, "語句"],
          [39, 41, "語句"],
          [75, 77, "語句"],
          [77, 79, "語句"],
          [107, 109, "語句"],
          [131, 138, "人物", "藤原経光", "作者"],
          [160, 162, "語句"],
        ],
        [
          [2, 4, "語句"],
          [15, 17, "語句"],
          [19, 21, "語句"],
        ],
        [[3, 5, "語句"]],
        [
          [3, 5, "語句"],
          [14, 17, "語句"],
          [23, 25, "人物"],
          [30, 32, "人物"],
          [33, 35, "人物"],
          [41, 49, "人物"],
          [74, 77, "語句"],
          [90, 92, "語句"],
          [98, 100, "語句"],
          [103, 105, "語句"],
          [108, 111, "人物"],
          [116, 118, "語句"],
          [122, 124, "語句"],
          [127, 129, "語句"],
          [148, 150, "語句"],
          [157, 159, "語句"],
          [163, 165, "語句"],
          [168, 170, "語句"],
          [170, 172, "語句"],
        ],
        [
          [4, 6, "語句"],
          [17, 19, "語句"],
          [30, 32, "語句"],
          [41, 43, "語句"],
          [32, 34, "語句"],
          [46, 48, "語句"],
          [51, 53, "語句"],
        ],
      ],
    };
  },
  components: {
    Token,
    TokenBlock,
    ClassesBlock,
  },
  computed: {
    ...mapState([
      "inputSentences",
      "classes",
      "annotations",
      "currentClass",
      "currentIndex",
    ]),
  },
  watch: {
    inputSentences() {
      this.resetIndex();
      this.tokenizeCurrentSentence();
    },
  },
  created() {
    if (this.inputSentences.length) {
      this.tokenizeCurrentSentence();
    }
    document.addEventListener("mouseup", this.selectTokens);
    // this.$store.commit("setAnnotations", this.inputSentences.length);
  },
  beforeUnmount() {
    document.removeEventListener("mouseup", this.selectTokens);
  },
  methods: {
    ...mapMutations(["nextSentence", "resetIndex", "backSentence"]),
    tokenizeCurrentSentence() {
      if (this.currentIndex >= this.inputSentences.length) {
        // TODO show completed message
        alert("You have completed all the sentences");
        return;
      }
      this.currentSentence = this.inputSentences[this.currentIndex];

      // let tokens = this.tokenizer.tokenize(this.currentSentence.text);
      let tokens = this.currentSentence.text.split("");

      // let spans = this.tokenizer.span_tokenize(this.currentSentence.text);
      let combined = tokens.map((t, i) => [i, i + 1, t]);
      this.tm = new TokenManager(combined);

      if (this.annotations[this.currentIndex]) {
        let next = this.annotations[this.currentIndex][1].entities;
        for (let i = 0; i < next.length; i++) {
          let nextblock = next[i];
          let nextClass = {};
          for (let i = 0; i < this.classes.length; i++) {
            if (nextblock[2] == this.classes[i].name) {
              nextClass = this.classes[i];
            }
          }
          // this.tm.addNewBlock(nextblock[0], nextblock[1] - 1, nextClass);
          if (Object.keys(nextblock).length < 3) {
            this.tm.addNewBlock(nextblock[0], nextblock[1] - 1, nextClass);
          } else {
            this.tm.addNewRoleBlock(
              nextblock[0],
              nextblock[1] - 1,
              nextClass,
              nextblock[3],
              nextblock[4]
            );
          }
        }
      }
      // 予測のお試し
      console.log(this.$store.state.annotations);
      // this.extract_token  = this.$store.state.annotations;
      let first_block = this.extract_token[this.currentIndex];
      for (let i = 0; i < first_block.length; i++) {
        let firstblock = first_block[i];
        let nextClass = {};
        for (let i = 0; i < this.classes.length; i++) {
          if (firstblock[2] == this.classes[i].name) {
            nextClass = this.classes[i];
          }
        }
        if (Object.keys(firstblock).length < 3) {
          this.tm.addNewBlock(firstblock[0], firstblock[1] - 1, nextClass);
        } else {
          this.tm.addNewRoleBlock(
            firstblock[0],
            firstblock[1] - 1,
            nextClass,
            firstblock[3],
            firstblock[4]
          );
        }
      }
    },
    backTokenizeCurrentSentence() {
      if (this.currentIndex < 0) {
        // TODO show completed message
        alert("スタートページです");
        return;
      }
      this.currentSentence = this.inputSentences[this.currentIndex];

      // let tokens = this.tokenizer.tokenize(this.currentSentence.text);
      let tokens = this.currentSentence.text.split("");
      // let spans = this.tokenizer.span_tokenize(this.currentSentence.text);
      let combined = tokens.map((t, i) => [i, i + 1, t]);

      let previous = this.annotations[this.currentIndex][1].entities;

      this.tm = new TokenManager(combined);

      for (let i = 0; i < previous.length; i++) {
        let preblock = previous[i];
        let preClass = {};
        for (let i = 0; i < this.classes.length; i++) {
          if (preblock[2] == this.classes[i].name) {
            preClass = this.classes[i];
          }
        }
        // this.tm.addNewBlock(preblock[0], preblock[1] - 1, preClass);
        if (Object.keys(preblock).length < 3) {
          this.tm.addNewBlock(preblock[0], preblock[1] - 1, preClass);
        } else {
          this.tm.addNewRoleBlock(
            preblock[0],
            preblock[1] - 1,
            preClass,
            preblock[3],
            preblock[4]
          );
        }
      }
    },
    selectTokens() {
      let selection = document.getSelection();
      console.log(this.currentClass.name);

      if (
        selection.anchorOffset === selection.focusOffset &&
        selection.anchorNode === selection.focusNode
      )
        return;
      let startIdx, endIdx;
      try {
        startIdx = parseInt(
          selection.anchorNode.parentElement.id.replace("t", "")
        );
        endIdx = parseInt(
          selection.focusNode.parentElement.id.replace("t", "")
        );
      } catch (e) {
        console.log("selected text were not tokens");
        return;
      }

      if (!this.classes.length && selection.anchorNode) {
        alert(
          "There are no Tags available. Kindly add some Tags before tagging."
        );
        selection.empty();
        return;
      }

      if (this.currentClass.name == "人物") {
        console.log(this.currentSentence)
        this.tm.addNewRoleBlock(startIdx, endIdx, this.currentClass, this.currentSentence.text.substring(startIdx,endIdx), "役職名");
        this.role = "役職名"
        // this.new_prompt = true;
      } else {
        this.tm.addNewBlock(startIdx, endIdx, this.currentClass);
      }
      selection.empty();
    },
    onRemoveBlock(blockStart) {
      this.tm.removeBlock(blockStart);
    },
    resetBlocks() {
      this.tm.resetBlocks();
    },
    skipCurrentSentence() {
      this.nextSentence();
      this.tokenizeCurrentSentence();
    },
    backCurrentSentence() {
      this.backSentence();
      this.backTokenizeCurrentSentence();
    },
    testClick: function(t, index) {
      if (t.label == "人物") {
        this.person = t.person;
        this.role = t.role;
        this.prompt = true;
        this.tm_index = index;
      }
    },
    changeRole: function() {
      this.tm.tokens[this.tm_index].role = this.role;
    },
    newRole: function() {
      console.log(this.tm.tokens)
      this.tm.tokens[this.tm.tokens.length - 1].role = this.role;
      console.log("newrole!")
      console.log(this.tm.tokens[this.tm_index].role)
      console.log(this.role)
    },
    saveTags: async function() {
      const response = await API.get("apitei", "/");
      console.log(response);
      this.$store.commit("addAnnotation", {
        index: this.currentIndex,
        content: [
          this.currentSentence.text,
          { entities: this.tm.exportAsAnnotation() },
        ],
      });
      console.log("save");
      this.nextSentence();
      this.tokenizeCurrentSentence();
    },
  },
};
</script>
